import { createEvent, EventAttributes } from "ics";
import { saveAs } from "file-saver";
import { fromUnixToArrayDates } from "../utils";

export const createEventIcs = (event?: EventAttributes) => {
  const eventCalendar: EventAttributes = {
    start: fromUnixToArrayDates(),
    duration: {
      hours: 0,
      minutes: 30,
    },
    status: "CONFIRMED",
    busyStatus: "BUSY",
    ...event,
  };

  createEvent(eventCalendar, (error, value) => {
    const blob = new Blob(
      [value],
      { type: "text/plain;charset=utf-8" },
    );

    saveAs(blob, "event-schedule.ics");
  });
};
